import type { CSSProperties, ReactNode } from "react";

/**
 * Cartão de seleção (Design.md §6.2/§6.3 / §9): borda laranja + marca ✓ quando
 * ativo. Usado em método de embalagem e transportadora. Pode ficar desabilitado
 * (ex.: transportadora própria — "exige autorização Admin", §6.3).
 */
export interface SelectionCardProps {
  selected: boolean;
  onSelect: () => void;
  title: ReactNode;
  children?: ReactNode;
  badge?: ReactNode;
  note?: ReactNode;
  disabled?: boolean;
  style?: CSSProperties;
}

export function SelectionCard({
  selected,
  onSelect,
  title,
  children,
  badge,
  note,
  disabled = false,
  style
}: SelectionCardProps): ReactNode {
  const borderColor = selected ? "var(--orange)" : "var(--border)";

  return (
    <button
      type="button"
      onClick={disabled ? undefined : onSelect}
      disabled={disabled}
      aria-pressed={selected}
      style={{
        position: "relative",
        textAlign: "left",
        width: "100%",
        background: selected ? "var(--orange-soft)" : "var(--panel)",
        border: `2px solid ${borderColor}`,
        borderRadius: 11,
        padding: "0.9rem 1rem",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        color: "var(--text)",
        display: "block",
        ...(style ?? {})
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "0.5rem"
        }}
      >
        <span style={{ fontSize: 14, fontWeight: 700 }}>{title}</span>
        <span style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem" }}>
          {badge}
          {selected ? (
            <span
              aria-hidden
              style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: "var(--orange)",
                color: "var(--on-orange)",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 12,
                fontWeight: 700
              }}
            >
              ✓
            </span>
          ) : null}
        </span>
      </div>
      {children !== undefined ? (
        <div style={{ marginTop: "0.5rem", fontSize: 12.5 }}>{children}</div>
      ) : null}
      {note !== undefined ? (
        <div
          style={{
            marginTop: "0.5rem",
            fontSize: 11.5,
            color: "var(--amber)",
            fontWeight: 600
          }}
        >
          {note}
        </div>
      ) : null}
    </button>
  );
}
